import React, { useState, useEffect } from "react";
import {
  Box,
  Text,
  useColorModeValue,
  useToast,
  Flex,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem,
  Button,
  Textarea,
} from "@chakra-ui/react";
import { cqAPI, getBid, getParam } from "../../lib/Auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import moment from "moment/moment";
import CustomizeAiHistoryHeader from "./CustomizeAIHistoryHeader";
import CustomizeAIDetail from "./CustomizeAIDetail";
import { useNavigate, useParams } from "react-router-dom";
import CustomizeAIAssistantInstruction from "./CustomizeAIAssistantInstruction";
import { INSTRUCTION_SECTIONS } from "./CustomizeAI";


const CustomizeAiHistoryDetail = () => {
  const bgColor = useColorModeValue("gray.100", "gray.700");
  const [history, setHistory] = useState([]);
  const [updatedAt, setUpdatedAt] = useState("");
  const [createdAt, setCreatedAt] = useState("");
  const toast = useToast();
  const bgBoxColor = useColorModeValue("#ffffff", '#212330');
  const { historyId } = useParams();
  const navigate = useNavigate();
  const assisted = getParam('assisted')
  const bid = getBid();

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        console.log(historyId);
        const response = await cqAPI.get("/settings/ai/history/?id=" + historyId);
        if (response.type === "ok") {
          setHistory(response?.data || []);
          setUpdatedAt(response?.data?.updated);
          setCreatedAt(response?.data?.created);
        }
      } catch (error) {
        console.error("Error loading the history:", error);
        toast({
          title: "Error",
          description: "Something Went Wrong! please try again.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };
    fetchHistory();
  }, []);

  const restoreVersion = async () => {
    try {
      console.log(historyId);
      const response = await cqAPI.put("/settings/ai/restore/?id=" + historyId);
      if (response.type === "ok") {
        console.log(response?.msg);
        toast({
          title: "Success",
          description: response?.msg || "AI settings restored successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        navigate(`/settings/customize-ai/?bid=${getBid()}`);
      }
    } catch (error) {
      console.error("Error restoring the history:", error);
      toast({
        title: "Error",
        description: "Something Went Wrong! please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  }

  return (
    assisted ?
      <Box my={8} px={4} width="100%" height="100%" overflowY="auto">
        <Box p={1} bgColor={bgColor} borderRadius="md" width="full">
          <Flex minH="70px" flexDirection="row" alignItems="center">
            <Flex justifyContent="flex-start" flexDirection="column" alignItems='start'>
              <Text align="start" fontSize="sm" fontWeight="bold" ml={2}>
                AI Setup Assistant
              </Text>
              <Text fontSize="sm" ml={2} mt={1}>
                Submitted: {createdAt && moment(createdAt).format("MMMM D, YYYY h:mm a")}
              </Text>
            </Flex>
            <Flex justifyContent="flex-end" gap={2} ml='auto' mr={4} minHeight="20px" minWidth="20px" align="center">
              <Button onClick={() => navigate(`/settings/customize-ai/history?bid=${bid}&assisted=1`)}>
                Close
              </Button>
            </Flex>
          </Flex>
        </Box>
        <Box mt={4} p={1} bgColor={bgColor} borderRadius="md" width="full">
          <Flex align="center" minH="90px" flexDirection="column" alignItems="start">
            <CustomizeAIAssistantInstruction instructions={history.draft_response_pre_prompt} inEditMode={false}/>
          </Flex>
        </Box>
      </Box>
      :
      <Box m={4} px={4} width="100%" height="100%" overflowY="auto" backgroundColor={bgBoxColor} borderRadius="8px">
        <CustomizeAiHistoryHeader assisted={assisted}/>
        <Box mt={4} p={1} bgColor={bgColor} borderRadius="md" width="full">
          <Flex align="center" minH="90px" flexDirection="column" alignItems="start">
            <Flex flexDirection="row" alignItems="center" width="100%">
              <Flex justifyContent="flex-start" flexDirection="column" mt={2} alignItems='start'>
                <Text fontSize="sm" fontWeight="bold" ml={2}>
                  AI Settings
                </Text>
                <Text fontSize="sm" ml={2} mt={1}>
                  Updated: {moment(updatedAt || createdAt).format("MMMM D, YYYY h:mm a")}
                </Text>
              </Flex>
              <Flex justifyContent="flex-end" ml='auto' gap={2} my={1} mr={2} minHeight="40px"
                    alignItems="center">
                <Menu flexBasis="5%">
                  <MenuButton as={IconButton} aria-label="Options"
                              icon={<FontAwesomeIcon icon={faEllipsisV}/>}
                              variant="ellipsis"/>
                  <MenuList>
                    <MenuItem onClick={restoreVersion}>
                      Restore this version
                    </MenuItem>
                  </MenuList>
                </Menu>
              </Flex>
            </Flex>
            <Flex minH="90px" flexDirection="column" gap={2} width="100%">
              <Flex flexDirection="column" align="start" m={4}>
                <Text fontSize="sm" fontWeight="bold" mb={2}>
                  General Instructions
                </Text>
                <Textarea
                  value={history.draft_response_pre_prompt || ""}
                  isDisabled={true}
                  height="400px"
                />
              </Flex>
              {INSTRUCTION_SECTIONS.map((section, idx) => {
                const showGroupHeader =
                  section.group && (idx === 0 || INSTRUCTION_SECTIONS[idx - 1].group !== section.group);
                return (
                  <React.Fragment key={section.key}>
                    {showGroupHeader && (
                      <Text fontSize="md" fontWeight="bold" mt={4} mb={1} ml={4} alignSelf="flex-start" textAlign="start">
                        {section.group}
                      </Text>
                    )}
                    <Flex flexDirection="column" align="start" mx={4} mb={2} ml={section.group ? 8 : 4}>
                      <Text fontSize="sm" fontWeight="bold" mb={2}>
                        {section.label}
                      </Text>
                      <Textarea
                        value={history[section.key] || ""}
                        isDisabled={true}
                        height="150px"
                      />
                    </Flex>
                  </React.Fragment>
                );
              })}
            </Flex>
          </Flex>
        </Box>
        <Box mt={4} p={1} bgColor={bgColor} borderRadius="md" width="full">

          <Flex align="center" minH="90px" flexDirection="column" alignItems="start">
            <Flex flexDirection="row" alignItems="center" width="100%">
              <Flex justifyContent="flex-start" flexDirection="column" mt={2} alignItems='start'>
                <Text fontSize="sm" fontWeight="bold" ml={2}>
                  AI Details
                </Text>
                {/*<Text fontSize="sm" ml={2} mt={1}>*/}
                {/*  Updated: {moment(updatedAt || createdAt).format("MMMM D, YYYY h:mm a")}*/}
                {/*</Text>*/}
              </Flex>
              <Flex justifyContent="flex-end" ml='auto' gap={2} mb={2} minHeight="40px" alignItems="center">
                {/*<Menu flexBasis="5%">*/}
                {/*  <MenuButton as={IconButton} aria-label="Options" icon={<FontAwesomeIcon icon={faEllipsisV}/>}*/}
                {/*              variant="ellipsis"/>*/}
                {/*  <MenuList>*/}
                {/*    <MenuItem onClick={restoreVersion}>*/}
                {/*      Restore this version*/}
                {/*    </MenuItem>*/}
                {/*  </MenuList>*/}
                {/*</Menu>*/}
              </Flex>
            </Flex>
            <CustomizeAIDetail organized_instructions={history?.organized_instructions}/>
          </Flex>
        </Box>
      </Box>
  )
};

export default CustomizeAiHistoryDetail;
